<template>
  <section>
    <Header/>
    <div class="notFound" v-if="notFound">
      <img src="../assets/not-found.png">
      <h4>404</h4>
      <h2>Halaman tidak ditemukan</h2>
      <p>Halaman yang kamu cari tidak ditemukan</p>
    </div>
    <div class="loading" v-else-if="loading"></div>
    <div v-else>
      <div class="bcnb">
        <div class="breadcrumb">
          <a :href="'/'" class="bc">Home</a>
          <span class="dv">/</span>
          <span class="bc">{{product.name}}</span>
        </div>
        <div class="backBtn" v-on:click="goBack"></div>
      </div>
      <div class="allContentCnt" v-if="product && product.submenu && product.submenu.length > 0">
        <h2 class="sectionTitle">{{product.name}}</h2>
        <div class="allContent">
          <div class="contentSc artc">
            <div class="contentCnt">
              <div class="contentItem artc product"
                v-for="(item, index) in product.submenu" :key="index">
                <div class="contentImg">
                  <div class="theImg" v-if="item.media"
                    :style="{'background-image': `url(${item.media.imageMd})`}">
                    <router-link :to="`/${item.slug}`"
                      class="lnk"></router-link>
                  </div>
                  <div class="theImg noImg" v-else>
                    <router-link :to="`/${item.slug}`"
                      class="lnk"></router-link>
                  </div>
                </div>
                <div class="contentInfo">
                  <h4><router-link :to="`/${item.slug}`">
                      {{item.name | substr(65, '...')}}
                  </router-link></h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Footer/>
  </section>
</template>

<script>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';

import '@splidejs/splide/dist/css/themes/splide-default.min.css';

export default {
  name: 'home',
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      notFound: false,
      loading: true,
      allSlider: [],
      featured: [],
      amagram: [],
      bsm: [],
      product: null,
      leaderNewsletter: [],
      bulletin10x: [],
      animatingHeart: null,
      animatingHeart2: null,
      animatingHeartC: null,
      animatingHeart2C: null,
      animatingHeartG: null,
      animatingHeart2G: null,
    };
  },
  methods: {
    sliderClicked(item) {
      if (item.buttonUrl) window.location.href = item.buttonUrl;
    },
    goBack() {
      window.history.back();
    },
    goto(uri) {
      this.$router.push(uri);
    },
  },
  mounted() {
    document.title = this.$config.appName;
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    const { slug } = this.$route.params;
    this.$http.get(this.$config.uri(`content/parent/${slug}`)).then((r) => {
      this.loading = false;
      this.product = (r.data.status === 200) ? r.data.data : null;
    });
  },
};
</script>

<style scoped lang="scss">
.bcnb{
  max-width: 1180px;
  margin: 0 auto;
  @media (max-width: 1300px) {
    max-width: 1140px;
  }
  @media (max-width: 1220px) {
    margin: 0 20px;
  }
  @media (max-width: 980px){
    // display: none;
  }
  @media (max-width: 680px){
    margin: 0 16px;
  }
  .breadcrumb{
    font-size: 14px;
    // border-bottom: #eee 1px solid;
    padding: 12px 0;
    @media (max-width: 680px){
      margin: 0;
      padding-bottom: 6px;
    }
    .bc{
      color: #444;
      margin-right: 10px;
    }
    a.bc{
      color: #002f5f;
    }
    .dv{
      margin-right: 10px;
      color: #ccc;
    }
  }
  .backBtn{
    width: 40px; height: 40px;
    border-radius: 50%;
    background-color: #fff;
    background-image: url(../assets/arrow-back.png);
    background-position: center;
    background-size: 20px auto;
    background-repeat: no-repeat;
    opacity: .5;
    margin-top: 10px;
    margin-left: -6px;
    cursor: pointer;
    @media (max-width: 1220px) {
      margin-top: 0;
    }
    &:hover{
      background-color: #eee;
      opacity: .9;
    }
  }
}

.notFound{
  position: absolute;
  left: 40px; right: 40px;
  top: 50%; transform: translateY(-50%);
  text-align: center;
  color: #767676;
  img{
    height: auto;
    width: 100%;
    max-width: 500px;
    margin-bottom: 40px;
  }
  h2{
    margin: 0 0 4px;
    font-size: 30px;
    line-height: 1;
  }
  h4{
    margin: 0;
    font-size: 50px;
    line-height: 1;
  }
  p{
    margin: 0;
  }
}

.slideShow{
  overflow: hidden;
  @media (min-width: 1480px) {
    width: 1180px;
    margin: 20px auto 0;
    border-radius: 10px;
    box-shadow: 2px 2px 2px rgba(0,0,0,.1);
  }
  .splide__slide{
    height: 460px;
    position: relative;
    @media (min-width: 1480px) {
      height: 348px;
    }
    @media (max-width: 669px) {
      height: 260px;
    }
    .slideItem{
      background-position: center;
      background-repeat: no-repeat;
      background-size: cover;
      position: absolute;
      left: 0; right: 0; top: 0; bottom: 0;
      .sic{
        position: absolute;
        left: 100px; top: 50%; transform: translateY(-50%);
      }
      h4{
        margin: 0 0 10px;
        color: #fff;
        color: #002f5f;
        font-size: 50px;
      }
      .btn{
        background-color: #002f5f;
        padding: 0 20px;
        height: 44px;
        line-height: 44px;
        font-size: 22px;
        display: inline-block;
        border-radius: 3px;
        color: #fff;
        border: none;
        font-weight: 600;
        outline: 0;
        cursor: pointer;
        transition: all .3s ease;
        &:hover{
          background-color: #004c9a;
          box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.loading{
  height: calc(100vh - 64px);
  background-image: url(../assets/loading.svg);
  background-size: 46px auto;
  background-position: center;
  background-repeat: no-repeat;
}
.sectionTitle{
  font-size: 32px;
  line-height: 1.3;
  margin: 0 auto 10px;
  max-width: 1180px;
  a{
    font-size: 17px;
    font-weight: normal;
    display: inline-block;
    border: #002f5f 1px solid;
    padding: 6px 10px 5px;
    border-radius: 2px;
    margin-top: 0px;
    float: right;
    transition: all .3s ease;
    &:hover{
      background-color: #002f5f;
      color: #fff;
      box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.2);
    }
  }
  @media (max-width: 1300px) {
    max-width: 1140px
  }
  @media (max-width: 1220px) {
    margin: 0 20px 10px;
    max-width: none;
    font-size: 26px;
  }
  @media (max-width: 680px) {
    font-size: 18px;
    margin: 0 16px 10px;
  }
}

.featuredCnt{
  padding: 60px 0;
  @media (max-width: 1300px) {
    padding: 40px 0;
  }
  @media (max-width: 669px) {
    padding: 20px 0 36px;
  }
  .featuredSc{
    max-width: 1180px;
    margin: 0 auto;
    box-sizing: border-box;
    @media (max-width: 1300px) {
      margin: 0 20px;
      max-width: none;
    }
    @media (max-width: 980px) {
      overflow-x: auto;
      margin-left: 0;
      margin-right: 0;
      padding-left: 30px;
      padding-bottom: 10px;
    }
    @media (max-width: 669px) {
      padding-left: 26px;
    }
  }
  .more{
    float: right;
    margin: 10px 20px 0 0;
    display: none;
    @media (max-width: 674px) {
      // margin-top: 3px;
    }
    img{
      height: 16px;
      float: right;
      margin: 3px 0 0 5px;
    }
    a{
      color: #6e35a4;
      &:hover{
        opacity: .9;
      }
    }
  }
  .featured{
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
    justify-content: center;
    @media (max-width: 980px) {
      width: 1200px;
    }
    @media (max-width: 669px) {
      width: 1000px;
    }
    .featuredItem{
      width: calc(25% - 20px);
      height: 500px;
      // background-color: #333;
      border-radius: 3px;
      margin: 0 10px 20px 10px;
      position: relative;
      overflow: hidden;
      color: #e5e5e5;
      transition: all .2s ease;
      @media (max-width: 1300px) {
        height: 30vw;
      }
      @media (max-width: 980px) {
        margin: 0 20px 0 0;
        height: 380px;
        transform: none !important;
      }
      @media (max-width: 669px) {
        height: 300px;
        margin: 0 16px 0 0;
        width: calc(25% - 16px);
      }
      a{
        color: #e5e5e5;
        text-decoration: none;
        &:hover{
          color: #fff;
        }
      }
      .featuredImg{
        position: absolute;
        top: -2px; right: -2px; bottom: -2px; left: -2px;
        background-size: cover;
        background-position: center;
        transition: all .2s ease;
        &.noImg{
          background-color: #999;
          background-image: url(../assets/image-white.png);
          background-size: 64px auto;
          background-repeat: no-repeat;
          background-position: center;
        }
        .lnk{
          position: absolute;
          left: 0; right: 0; top: 0; bottom: 0;
          display: block;
          z-index: 2;
        }
      }
      &:hover{
        transform: scale(1.05);
        .featuredImg{
          // left: -20px; right: -20px; top: -20px; bottom: -20px;
        }
      }
      .featuredInfo{
        position: absolute;
        left: 0; bottom: 0; right: 0;
        padding: 50px 40px 10px 20px;
        border-radius: 3px;
        z-index: 3;
        background-image: linear-gradient(to top, rgba(0,0,0,.7), transparent);
        .lnk{
          position: absolute;
          left: 0; top: 0; right: 0;
          height: 50px;
        }
        .contentLove{
          width: 36px; height: 36px;
          border-radius: 4px;
          position: absolute;
          right: 12px; bottom: 15px;
          background-image: url(../assets/heart-white.png);
          background-size: 26px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .7;
          cursor: pointer;
          border-radius: 50%;
          &:hover{
            opacity: 1;
          }
          &.favorited{
            opacity: 1;
            background-image: url(../assets/heart-loved.png);
          }
          &.animating{
            opacity: 1;
            animation-name: heartAnimation;
            animation-duration: .3s;
          }
          &.animating2{
            animation-name: heartAnimation2;
            animation-duration: .3s;
          }
        }
        .category{
          text-transform: uppercase;
          font-weight: bold;
          font-size: 12px;
        }
        h4{
          margin: 0 0 6px;
          font-size: 20px;
          line-height: 1.2;
          @media (max-width: 1100px) {
            font-size: 16px;
          }
        }
        .liveClass{
          color: #ff4e45;
          border: #ff4e45 1px solid;
          border-radius: 3px;
          padding: 5px 6px 4px;
          margin: 6px 0 2px;
          background-color: rgba(0,0,0,.5);
          font-size: 14px;
          display: inline-block;
          font-weight: 500;
          line-height: 1;
        }
        .teacher{
          margin: 10px 0 8px;
          position: relative;
          padding-left: 36px;
          .icon{
            width: 30px; height: 30px;
            background-color: #fb7cb3;
            position: absolute;
            border-radius: 50%;
            left: 0; top: -5px;
            display: flex;
            justify-content: center;
            align-items: center;
            background-position: center;
            background-size: cover;
            span{
              text-transform: uppercase;
              font-size: 12px;
            }
            &.hasPhoto{
              span{
                display: none;
              }
            }
          }
          h4{
            font-size: 17px;
            font-weight: 500;
            margin: 0;
          }
        }
        .teacherIcons{
          position: relative;
          display: flex;
          align-items: center;
          margin: 5px 0 3px 10px;
          .icon{
            width: 30px; height: 30px;
            background-color: #fb7cb3;
            border-radius: 50%;
            display: flex;
            justify-content: center;
            align-items: center;
            background-position: center;
            background-size: cover;
            margin-left: -10px;
            span{
              text-transform: uppercase;
              font-size: 12px;
            }
            &.hasPhoto{
              span{
                display: none;
              }
            }
          }
          h4{
            font-size: 17px;
            font-weight: 500;
            padding-left: 10px;
            padding-top: 1px;
            margin: 0;
          }
        }
        .pricing{
          font-size: 16px;
          margin: 8px 0;
          .thePrice{
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 20px;
            position: relative;
            padding-left: 22px;
            &:before{
              content: "";
              position: absolute;
              left: 0; top: 0;
              width: 16px; height: 16px;
              background-image: url(../assets/private-white.png);
              background-size: contain;
              background-position: center;
              background-repeat: no-repeat;
            }
            &.purchased{
              &:before{
                background-image: url(../assets/checkmark.png);
                top: 1px;
              }
            }
          }
        }
        .date{
          font-size: 12px;
        }
      }
    }
  }
}
.allContentCnt{
  padding-bottom: 40px;
  @media (max-width: 669px) {
    padding-bottom: 20px;
  }
  .allContent{
    max-width: 1180px;
    margin: 0 auto;
    @media (max-width: 1300px) {
      margin: 0 20px;
      max-width: none;
    }
    @media (max-width: 960px) {
      margin: 0;
    }
    .contentCnt{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
      justify-content: center;
    }
    .contentItem{
      width: calc(20% - 20px);
      margin: 0 10px;
      a{
        color: #444;
        text-decoration: none;
      }
      .contentImg{
        height: 400px;
        border-radius: 2px;
        margin-bottom: 14px;
        position: relative;
        overflow: hidden;
        @media (max-width: 1100px) {
          // height: 360px;
        }
        @media (max-width: 669px) {
        }
        .theImg{
          position: absolute;
          top: -2px; right: -2px; bottom: -2px; left: -2px;
          background-position: center;
          background-size: cover;
          background-color: #f5f5f5;
          &.noImg{
            background-color: #ccc;
            background-image: url(../assets/image-white.png) !important;
            background-position: center;
            background-size: 64px auto;
            background-repeat: no-repeat;
          }
          .lnk{
            position: absolute;
            left: 0; top: 0; right: 0; bottom: 0;
            z-index: 2;
          }
        }
      }
      .contentInfo{
        position: relative;
        padding: 0 40px 0 5px;
        @media (max-width: 669px) {
          padding-left: 3px;
        }
        .contentLove{
          width: 36px; height: 36px;
          border-radius: 4px;
          position: absolute;
          right: 0; top: 0;
          background-image: url(../assets/heart.png);
          background-size: 26px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .7;
          cursor: pointer;
          &:hover{
            // background-color: #fff1f1;
            opacity: 1;
          }
          &.favorited{
            opacity: 1;
            background-image: url(../assets/heart-loved.png);
          }
          &.animating{
            opacity: 1;
            animation-name: heartAnimation;
            animation-duration: .3s;
          }
          &.animating2{
            animation-name: heartAnimation2;
            animation-duration: .3s;
          }
        }
        .category{
          text-transform: uppercase;
          color: #767676;
          font-size: 12px;
          font-weight: bold;
          a{
            color: #767676;
          }
        }
        h4{
          margin: 3px 0 6px;
          font-size: 18px;
          line-height: 1.2;
          text-transform: uppercase;
          @media (max-width: 1340px) {
            font-size: 17px;
          }
        }
        .date{
          margin-top: 4px;
          font-size: 14px;
          color: #767676;
          a{
            color: #767676;
          }
        }
      }
    }
  }
}

.allContentCnt{
  padding: 40px 0 20px;
  @media (max-width: 680px) {
    padding: 20px 0;
  }
  .allContent{
    max-width: 1180px;
    margin: 0 auto;
    @media (max-width: 1300px) {
      max-width: 1140px;
    }
    @media (max-width: 1220px) {
      max-width: none;
      margin: 0 20px;
    }
    @media (max-width: 680px) {
      margin: 0 16px;
    }
    .contentCnt{
      display: flex;
      flex-wrap: wrap;
      margin: 0 -10px;
      justify-content: left;
      @media (max-width: 680px) {
        margin: 0 -8px;
      }
    }
    .contentItem{
      width: calc(25% - 20px);
      margin: 0 10px;
      @media (max-width: 680px) {
        width: calc(50% - 16px);
        margin: 0 8px;
      }
      a{
        color: #444;
        text-decoration: none;
      }
      .contentImg{
        height: 500px;
        border-radius: 2px;
        margin-bottom: 14px;
        position: relative;
        overflow: hidden;
        @media (max-width: 1300px) {
          height: 480px;
        }
        @media (max-width: 1220px) {
          height: 40vw;
        }
        @media (max-width: 680px) {
          height: 78vw;
        }
        .theImg{
          position: absolute;
          top: -2px; right: -2px; bottom: -2px; left: -2px;
          background-position: center;
          background-size: cover;
          background-color: #f5f5f5;
          &.noImg{
            background-color: #ccc;
            background-image: url(../assets/image-white.png) !important;
            background-position: center;
            background-size: 64px auto;
            background-repeat: no-repeat;
          }
          .lnk{
            position: absolute;
            left: 0; top: 0; right: 0; bottom: 0;
            z-index: 2;
          }
        }
      }
      .contentInfo{
        position: relative;
        padding: 0 0 0 5px;
        .contentLove{
          width: 36px; height: 36px;
          border-radius: 4px;
          position: absolute;
          right: 0; top: 0;
          background-image: url(../assets/heart.png);
          background-size: 26px auto;
          background-position: center;
          background-repeat: no-repeat;
          opacity: .7;
          cursor: pointer;
          &:hover{
            // background-color: #fff1f1;
            opacity: 1;
          }
          &.favorited{
            opacity: 1;
            background-image: url(../assets/heart-loved.png);
          }
          &.animating{
            opacity: 1;
            animation-name: heartAnimation;
            animation-duration: .3s;
          }
          &.animating2{
            animation-name: heartAnimation2;
            animation-duration: .3s;
          }
        }
        .category{
          text-transform: uppercase;
          color: #767676;
          font-size: 12px;
          font-weight: bold;
          a{
            color: #767676;
          }
        }
        h4{
          margin: 3px 0 6px;
          font-size: 18px;
          line-height: 1.2;
          @media (max-width: 1340px) {
            font-size: 17px;
          }
        }
        .date{
          margin-top: 4px;
          font-size: 14px;
          color: #767676;
          a{
            color: #767676;
          }
        }
      }
      &.product{
        margin-bottom: 60px;
        @media (max-width: 680px) {
          margin-bottom: 40px;
        }
        .contentImg{
          height: 280px;
          @media (max-width: 1129px) {
            height: 200px;
          }
          @media (max-width: 960px) {
            height: 170px;
          }
          @media (max-width: 690px) {
            height: 160px;
          }
        }
        .contentInfo{
          text-align: center;
        }
      }
      &.bsm{
        width: calc(50% - 20px);
        .contentImg{
          height: 460px;
        }
        .contentInfo{
          h4{
            font-size: 30px;
          }
        }
      }
    }
  }
}


@keyframes heartAnimation {
  from {
    transform: scale(.4);
  }
  to {
    transform: scale(1.2);
  }
}
@keyframes heartAnimation2 {
  from {
    transform: scale(1.2);
  }
  to {
    transform: scale(1);
  }
}

</style>
